import {
  AppBar,
  Button,
  ButtonGroup,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import "../index.css";
import http from "../services/httpService";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import handleValidation from "../utils/handleValidations";
import { vantagePath } from "../utils/varialbles";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    width: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
function AddEfg() {
  let history = useHistory();
  const [questionner, setQuestionner] = useState([]);
  const location = useLocation();
  const [efgActive, setEfgActive] = useState(true);
  const [ratingArray, setRatingArray] = useState([]);
  const [ratingState, setratingState] = useState({});

  const myparam = location.state;
  let form = {
    Question: "",
    Evaluation: "",
    Category: "",
    Type: "",
    Section: "",
    Options: "",
    Status: false,
  };
  const [formObject, setFromObject] = useState(form);
  const validations = {
    Question: {
      conditions: {
        required: true,
        maxWordLength: 20,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    Evaluation: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    Category: {
      conditions: {
        required: true,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    Type: {
      conditions: {
        required: true,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    Section: {
      conditions: {
        required: true,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    // ,
    // "Options": {
    //     conditions: {
    //         "required": true,"minWordLength":2,"delimiter":","
    //     }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
    // }
  };
  const [validationState, setValidationState] = useState(validations);
  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    {
      lable: "Question",
      imp: true,
      filedType: "text",
      value: "Question",
      display: true,
    },
    {
      lable: "Evaluation",
      imp: true,
      filedType: "dropDown",
      value: "Evaluation",
      display: true,
    },
    {
      lable: "Category",
      imp: true,
      filedType: "dropDown",
      value: "Category",
      display: true,
    },
    {
      lable: "Type",
      imp: true,
      filedType: "dropDown",
      value: "Type",
      display: true,
    },
    {
      lable: "Section",
      imp: true,
      filedType: "dropDown",
      value: "Section",
      display: true,
    },
    {
      lable: "Options",
      imp: true,
      filedType: "text",
      value: "Options",
      display: true,
    },
    {
      value: "Status",
      lable: "Status",
      minWidth: 150,
      imp: true,
      filedType: "radio",
      display: true,
      boolean: true,
      options: [
        { label: "Active", value: true },
        { label: "Inactive", value: false },
      ],
    },
  ];
  const classes = useStyles();
  const gotoEFG = () => {
    history.push({
      pathname: vantagePath,
      state: { tab: "EFG Admin", subTab: "Efg Questions" },
    });
  };
  const handleCancel = () => {
    http
      .get("/efgcreate" + "?otp=" + location.otp)
      .then((response) => {
        if (
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          setQuestionner(response.data.Data);
        } else {
          // toast.error("Questioner Data Not Available for this investor..!");
          gotoEFG();
        }
      })
      .catch((error) => {
        // toast.error("Questioner Data Not Available for this investor..!");
        gotoEFG();
      });
  };
  useEffect(() => {
    handleCancel();
  }, []);
  const handleChange = (event, boolean) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    if (boolean && value === "false") {
      value = false;
    } else if (boolean && value == "true") {
      value = true;
    }
    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      setFromObject({
        ...formObject,
        [event.target.name]: value,
      });
    }
    if (name === "Options") {
      let split = value.split(",");
      let keys = { ...ratingState };
      let keyArray = [];
      let ratingA = split.map((str, inx) => {
        let key = "Option" + (inx + 1) + "score";
        if (!keys.hasOwnProperty(key)) {
          keys["Option" + (inx + 1) + "score"] = "";
        }
        keyArray.push(key);
        return {
          inx: inx + 1,
          lable: "Option " + (inx + 1) + " score",
          key: key,
        };
      });
      Object.keys(keys).map((key, inx) => {
        if (keyArray.indexOf(key) === -1) {
          delete keys[key];
        }
      });
      if (value === "") {
        setRatingArray([]);
        setratingState({});
      } else {
        setRatingArray(ratingA);
        setratingState(keys);
      }
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };

    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    if (validCount === 0) {
      userQuestionnaire.map((obj) => {
        let filter = [];
        if (obj["filedType"] == "dropDown" && !obj["boolean"]) {
          filter = questionner.filter((question) => {
            return question.question === obj.lable;
          });
          if (filter.length > 0) {
            let value = filter[0].options.filter((option) => {
              return option.values === finalObjet[obj.value];
            });
            if (value.length > 0) {
              finalObjet[obj.value] = value[0]["name"];
            }
          }
        }

        if (obj["boolean"] && finalObjet[obj.value] != 1) {
          finalObjet[obj.value] = 0;
        }
      });
      let finalRating = [];
      Object.keys(ratingState).map((key, inx) => {
        finalRating.push(Number(ratingState[key]));
      });
      finalObjet["Rating"] = finalRating.join();
      finalObjet["Section"] = finalObjet["Section"].slice(0, 1);

      http
        .post("/efgcreate", finalObjet)
        .then((response) => {
          if (response.data.id) {
            toast.success("Efg Created Successfully!");
            gotoEFG();
            handleCancel();
          } else {
            toast.error("Efg Creation Failed!");
          }
        })
        .catch((error) => {
          toast.error("Efg Creation Failed!");
        });
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };
  const handleRatingChange = (event) => {
    setratingState({
      ...ratingState,
      [event.target.name]: event.target.value,
    });
  };
  return (
    <Grid container component="main">
      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
        className={classes.paper}
      >
        <Grid container component="main">
          <Grid item xs={6} sm={6} md={6}>
            <ButtonGroup>
              {/* <Button variant={publishedActive ? "contained" : "outlined"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} onClick={() => makeActive("/contentmanagement")} name="invOverView">Lists</Button> */}
              <Button
                variant={efgActive ? "contained" : "outlined"}
                color="primary"
                style={{ marginLeft: 10, borderRadius: 60 }}
                name="archivedPostsButton"
                onClick={gotoEFG}
              >
                EFG Admin
              </Button>
              {/* <Button variant={archivedActive ? "contained" : "outlined"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} onClick={() => makeActive("/contentmanagement")} name="publishedPostsButton">Stock Closure Upload</Button> */}
            </ButtonGroup>
          </Grid>
        </Grid>
      </AppBar>
      <Grid item xs={false} sm={5} md={5}></Grid>
      <Grid item xs={false} sm={5} md={5}>
        <Typography color="textPrimary" variant="h5">
          Add New EFG question
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: 50 }}>
        {userQuestionnaire.map((question) => {
          return question.display ? (
            <Grid container className={classes.paper} key={question.value}>
              <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                <InputLabel
                  className={classes.lableColor}
                  id={question.lable + "label"}
                  style={{ paddingTop: "6px" }}
                >
                  {question.lable}
                  {question.imp && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "0.2rem",
                      }}
                    >
                      *
                    </span>
                  )}
                </InputLabel>
              </Grid>
              <Grid item lg={5} md={5} sm={5}>
                {question.filedType === "dropDown" ? (
                  questionner
                    .filter((obj) => {
                      return obj.question === question.lable;
                    })
                    .map((a) => {
                      return (
                        <>
                          <Select
                            displayEmpty
                            labelId={question.lable + "label"}
                            id="statusSelect"
                            variant="outlined"
                            className={classes.select}
                            onChange={handleChange}
                            value={
                              formObject[question.value]
                                ? formObject[question.value]
                                : ""
                            }
                            name={question.value}
                          >
                            <MenuItem value="">Select</MenuItem>
                            {a.options.map((option) => {
                              return (
                                <MenuItem
                                  value={option.values}
                                  key={option.values + question.value}
                                >
                                  {option.name}
                                </MenuItem>
                              );
                            })}
                            )
                          </Select>{" "}
                          {validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"] ? (
                            <div
                              style={{
                                color: "#f44336",
                                fontSize: "0.75rem",
                                margin: "3px 14px",
                              }}
                            >
                              {validationState[question.value]["message"]}
                            </div>
                          ) : null}
                        </>
                      );
                    })
                ) : question.filedType === "radio" ? (
                  <RadioGroup
                    row
                    aria-label="position"
                    name={question.value}
                    defaultValue={false}
                    value={
                      formObject[question.value]
                        ? formObject[question.value]
                        : false
                    }
                    onChange={(e) => handleChange(e, true)}
                  >
                    {question.options.map((option) => {
                      return (
                        <FormControlLabel
                          control={
                            <Radio
                              classes={{
                                root: classes.radio,
                                checked: classes.checked,
                              }}
                              value={option.value}
                            />
                          }
                          label={option.label}
                          labelPlacement="end"
                        />
                      );
                    })}
                  </RadioGroup>
                ) : (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    className={classes.select}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? { paddingBottom: 20 }
                        : {}
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                )}
              </Grid>
            </Grid>
          ) : (
            ""
          );
        })}
        {ratingArray.length > 0 ? (
          <Grid item xs={12} style={{ marginTop: 30 }}>
            <Typography color="textPrimary" variant="h6">
              Rating{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </Typography>
          </Grid>
        ) : (
          ""
        )}
        {ratingArray.map((obj, inx) => {
          return (
            <Grid container className={classes.paper} key={obj.key}>
              <Grid item xs={false} sm={2} md={2}>
                <InputLabel
                  className={classes.lableColor}
                  id={obj.key + "label"}
                  style={{ paddingTop: "6px" }}
                >
                  {obj.lable}
                </InputLabel>
              </Grid>
              <Grid item xs={5} sm={5} md={5}>
                <TextField
                  label="Enter"
                  variant="outlined"
                  name={obj.key}
                  onChange={handleRatingChange}
                  className={classes.select}
                  value={ratingState[obj.key]}
                  type="number"
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>

      <Grid container className={classes.submitButton}>
        <Grid item xs={false} sm={2} md={2}></Grid>
        <Grid item xs={3} sm={1} md={1}>
          {/* <Button variant="outlined" color="default" onClick={handleCancel}>Cancel</Button> */}
        </Grid>

        <Grid item xs={3} sm={1} md={1}>
          {
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Add
            </Button>
          }
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddEfg;
